import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const IncomeIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/b2d6b36aa19b6d6b8a2b7c3d3ea8b1db_IncomeIcon.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/77f25a5a519605e3d4d74df18804b925_IncomeIcon_2x.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/4807feb3ca15ae08a639dedc9698eb83_IncomeIcon_3x.png'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/b2d6b36aa19b6d6b8a2b7c3d3ea8b1db_IncomeIcon.png'
        }
        width={128}
        height={128}
        alt={''}
      />
    </div>
  )
}
